import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class PreviewMessage extends Component {
    render() {
        const { text, style, elementRef } = this.props;

        return (
            <div className="message-box"
                ref={elementRef}
                style={{
                    ...style
                }}>
                {text}
            </div>
        );
    }
}

PreviewMessage.propTypes = {
    text: PropTypes.string,
    style: PropTypes.object,
    elementRef: PropTypes.func
};

PreviewMessage.defaultProps = {
    text: ''
};
